import Tool from 'Src/util/tool'
import { SELECT, RANGE_INPUT } from 'Src/components/reporter/input/input-type.js'
import LegalText from 'Src/const/cross-end-delivery-words/index.js'
// 标识是否有信息流权限
const advFeedTag = JSON.parse(GLOBAL_VAR.adv_feed_tag) || false

export const filterForObj = function (obj, callback) {
  if (typeof obj !== 'object' && typeof callback !== 'function') {
    return obj
  }
  let newObj = {}
  Object.keys(obj).forEach(key => {
    callback(obj[key], key) && (newObj[key] = obj[key])
  })
  return newObj
}

// 汇总方式
export const statMethod = {
  BY_HOUR: {
    value: 2,
    text: $bp_t('分时', 'common.time_sharing'),
    code: 'stat_time_hour'
  },
  BY_DAY: {
    value: 1,
    text: $bp_t('分日', 'common.fractional_day'),
    code: 'stat_time_day'
  },
  BY_WEEK: {
    value: 3,
    text: $bp_t('分周', 'bp.statistics_filter_weekly'),
    code: 'stat_time_week'
  },
  BY_MONTH: {
    value: 4,
    text: $bp_t('分月', 'bp.statistics_filter_monthly'),
    code: 'stat_time_month'
  },
  TOTAL: {
    value: 0,
    text: $bp_t('合计', 'bp.statistics_filter_total'),
    code: ''
  }
}

export function getStatCodeByValue (value) {
  let code = ''
  Object.keys(statMethod).map(key => {
    if (statMethod?.[key]?.value === value) {
      code = statMethod?.[key]?.code
    }
  })
  return code
}

// 细分维度
const dimensionsBase = [
  {
    text: $bp_t('无', 'common.nothing'),
    value: 'default'
  }, {
    text: LegalText.reports.delivery_postion,
    value: 'app_code',
    isSupported: Tool.isBp() || advFeedTag
  }, {
    text: $bp_t('推广目的', 'common.landing_type'),
    value: 'landing_type'
  }, {
    text: $bp_t('计费方式', 'common.billing_mode'),
    value: 'pricing'
  }, {
    text: $bp_t('创意样式', 'bp.statistics_filter_creative_style'),
    value: 'image_mode',
    isSupported: !Tool.isBp()
  }, {
    text: $bp_t('创意方式', 'bp.statistics_filter_creative_generation_style'),
    value: 'creative_material_mode'
  }, {
    text: $bp_t('性别', 'common.gender'),
    value: 'gender'
  }, {
    text: $bp_t('年龄', 'common.age'),
    value: 'age'
  }, {
    text: $bp_t('省份', 'common.province'),
    value: 'province_name'
  }, {
    text: $bp_t('城市Top20', 'common.city_top_twenty'),
    value: 'city_name'
  }, {
    text: $bp_t('兴趣分类', 'common.interest_classification'),
    value: 'interest_category_name'
  }, {
    text: $bp_t('平台', 'common.platform'),
    value: 'platform'
  }, {
    text: $bp_t('网络', 'common.network'),
    value: 'ac'
  }
]
export const dimensions = dimensionsBase.filter(val => val.isSupported !== false)

// 广告类型
const pricingCategory = {
  BRAND: {
    value: 1,
    text: $bp_t('品牌', 'bp.statistics_filter_brand')
  },
  BID: {
    value: 2,
    text: $bp_t('竞价', 'bp.statistics_filter_bidding_price')
  }
}

// 广告组类型
export const campaignType = {
  NEWS_FEED: {
    value: 1,
    text: LegalText.reports.feeds
  },
  SEARCH_AD: {
    value: 2,
    text: $bp_t('搜索广告', 'bp.const_campaign_search_advertising')
  }
}

// 投放模式
const deliveryMode = {
  MANUAL: {
    value: 1,
    text: '标准投放'
  },
  AUTOMATIC: {
    value: 2,
    text: '管家&省心投放'
  }
}

// 推广目的
const landingType = {
  EXTERNAL: {
    value: 1,
    text: $bp_t('销售线索收集', 'common.lead_collection')
  },
  ARTICLE: {
    value: 2,
    text: $bp_t('头条文章推广', 'common.headline_promotion')
  },
  DOWNLOAD: {
    value: 3,
    text: $bp_t('应用推广', 'common.application_and_popularization')
  },
  GOODS: {
    value: 4,
    text: $bp_t('商品推广', 'common.catalogue')
  },
  PRODUCT_LIBRARY: {
    value: 5,
    text: $bp_t('商品目录推广', 'bp.const_campaign_catalogue_promotion')
  },
  ADVERTISER_STORE: {
    value: 6,
    text: $bp_t('门店推广', 'common.store_promotion')
  },
  AWEME_POPULARIZE: {
    value: 7,
    text: $bp_t('抖音号推广', 'common.promotion_of_buffeting_signal')
  },
  SHOP: {
    value: 8,
    text: $bp_t('电商店铺推广', 'common.e_commerce_shop_promotion')
  },
  QUICK_APP: {
    text: $bp_t('快应用', 'common.const_common_quick_app'),
    value: 10
  },
  LIVE: {
    value: 9,
    text: $bp_t('直播间', '')
  }
}
// 计费方式
const pricing = {
  oCPM: { value: 9, text: 'oCPM' },
  oCPC: { value: 7, text: 'oCPC' },
  CPA: { value: 8, text: 'CPA' },
  CPC: { value: 2, text: 'CPC' },
  CPM: { value: 1, text: 'CPM' },
  CPV: { value: 10, text: 'CPV' },
  CPT: { value: 3, text: 'CPT' },
  GD: { value: 6, text: 'GD' },
  CPCOCPM: { value: 11, text: 'CPC-oCPM' }
}

// 投放位置
const appCode = {
  FEED: {
    value: 8,
    text: $bp_t('今日头条', 'common.today_s_headlines')
  },
  TOUTIAO_VIDEO: {
    value: 1,
    text: $bp_t('西瓜视频', 'common.watermelon_video')
  },
  HOTSOON_VIDEO: {
    value: 3,
    text: $bp_t('抖音火山版', 'common.volcano_video')
  },
  AWEME_FEED: {
    value: 4,
    text: $bp_t('抖音', 'common.jitter')
  },
  HOMEDAPP_OPTIONS: {
    value: 25,
    text: $bp_t('住小帮', '')
  },
  UNION_SLOT: {
    value: 9,
    text: $bp_t('穿山甲', 'common.pangolin')
  },
  YOU_XUAN: {
    text: $bp_t('通投智选', 'common.universal_delivery'),
    value: 33,
    isSupported: Tool.isBp() || Tool.isSupported(GLOBAL_VAR.adver_func.universal_delivery)
  },
  SEARCH: {
    text: $bp_t('搜索广告位', 'common.universal_delivery'),
    value: 38,
    isSupported: Tool.isBp() || advFeedTag
  },
  NOVELAPP: {
    text: '番茄小说',
    value: 26
  },
  UNION_SMART_GAME: {
    value: 27,
    text: LegalText.common.pangolin_selected_leisure_games,
    isSupported: Tool.isBp() || Tool.isSupported(GLOBAL_VAR.union_smart_game_white)
  }
}

const appCodeDpa = filterForObj(appCode, (val, key) => !['UNION_SMART_GAME'].includes(key) && val.isSupported !== false)
appCodeDpa.FEED = { value: 2, text: $bp_t('今日头条系', 'common.todays_headlines') }

// 转化跟踪方式Dpa
const convertTypeDpa = {
  EXTERNAL_JS: {
    value: 1,
    text: $bp_t('落地页-JS', 'bp.statistics_filter_landing_page_js')
  },
  EXTERNAL_XPATH: {
    value: 2,
    text: $bp_t('落地页-Xpath', 'bp.statistics_filter_landing_page_xpath')
  },
  APP_ACTIVE: {
    value: 3,
    text: $bp_t('APP-激活', 'bp.statistics_filter_app_activation')
  },
  EXTERNAL_API: {
    value: 5,
    text: $bp_t('落地页-API', 'bp.statistics_filter_landing_api')
  },
  SDK: {
    value: 9,
    text: 'SDK'
  },
  APP_DOWNLOAD_FINISH: {
    value: 10,
    text: $bp_t('落地页API-应用直达链接', 'bp.statistics_filter_landing_page_api')
  }
}

// 转化目标dpa
const externalActionDpa = {
  FORM: {
    value: 2,
    text: $bp_t('表单提交', 'common.form')
  },
  ACTIVE: {
    value: 8,
    text: $bp_t('激活', 'common.activation')
  },
  IN_APP_UV: {
    value: 21,
    text: $bp_t('app内访问', 'common.app_internal_access')
  },
  IN_APP_DETAIL_UV: {
    value: 29,
    text: $bp_t('app内详情页到站uv', 'common.app_internal_details_page_arrival_uv')
  }
}

// 设备
const platform = {
  ANDROID: {
    value: 1,
    text: 'Android'
  },
  IOS: {
    value: 2,
    text: 'iOS'
  }
}

// 创意样式
export const imageMode = {
  MINI_IMAGE: {
    value: 2,
    text: $bp_t('小图', 'common.small_graph')
  },
  VERTICAL_LARGE_IMAGE: {
    value: 16,
    text: $bp_t('大图竖图', 'common.large_vertical_drawing')
  },
  LARGE_IMAGE: {
    value: 3,
    text: $bp_t('大图横图', 'common.large_graph')
  },
  GROUP_IMAGE: {
    value: 4,
    text: $bp_t('组图', 'common.group_diagram')
  },
  VIDEO: {
    value: 5,
    text: $bp_t('横版视频', 'common.horizontal_video')
  },
  VERTICAL_VIDEO: {
    value: 15,
    text: $bp_t('竖版视频', 'common.vertical_video')
  },
  PLABLEABLE: {
    value: 170,
    text: $bp_t('横版试玩', '')
  },
  VERTICAL_PLABLEABLE: {
    value: 171,
    text: $bp_t('竖版试玩', '')
  },
  SPLASH_IMAGE: {
    value: 131,
    text: $bp_t('穿山甲', 'common.pangolin') + '开屏图片'
  },
  LIVE: {
    value: 166,
    text: $bp_t('直播画面', 'common.live_picture')
  },
  SEARCH_SHOPWINDOW: {
    value: 156,
    text: $bp_t('搜索橱窗', 'bp.search_shopwindow')
  },
  // 融合或者搜索支持搜索大图小图
  SEARCH_LARGE_IMAGE: {
    value: 148,
    text: $bp_t('搜索大图', 'common.search_for_larger_maps')
  },
  SEARCH_MINI_IMAGE: {
    value: 157,
    text: $bp_t('搜索小图', 'common.search_small_graph')
  },
  // 穿山甲-开屏视频白名单支持
  SPLASH_VIDEO: {
    value: 154,
    text: $bp_t('穿山甲', 'common.pangolin') + '开屏视频',
    isSupported: Tool.isBp() || Tool.isSupported(GLOBAL_VAR.hasUnionSplash)
  },
  DECORATION_LEAGUE_COUPON: {
    value: 188,
    text: '家装联盟卡券'
  }
}

// 创意方式
const creativeMaterialMode = {
  CUSTOM_IDEAS: {
    text: $bp_t('自定义创意', 'common.custom_ideas'),
    value: 2
  },
  PROCEDURAL_CREATIVITY: {
    text: $bp_t('程序化创意', 'common.procedural_creativity'),
    value: 3
  }
}

// 是否使用抖音号
const useDouyinOptions = {
  USE: {
    text: $bp_t('使用', 'common.use_douyin'),
    value: 1
  },
  DONT_USE: {
    text: $bp_t('不使用', 'common.dont_use_douyin'),
    value: 2
  }
}

// 平台版本
export const platformVersionOptions = {
  V1: {
    text: '原版',
    value: 1
  },
  V2: {
    text: '新版',
    value: 2
  }
}

export const commonSetDataFilterConfig = {
  pricingCategory: {
    type: SELECT,
    key: 'pricingCategory',
    paramValue: 'pricing_category',
    label: $bp_t('广告类型', 'common.advertising_type'),
    props: {
      multiple: true,
      emptyValue: [],
      optionList: pricingCategory
    }
  },
  campaignType: {
    type: SELECT,
    key: 'campaignType',
    paramValue: 'campaign_type',
    label: $bp_t('广告组类型', 'bp.statistics_fields_promotion_ad_group_type'),
    props: {
      multiple: true,
      emptyValue: [],
      optionList: campaignType
    }
  },
  deliveryMode: {
    type: SELECT,
    key: 'deliveryMode',
    paramValue: 'delivery_mode',
    label: '投放模式',
    hint: '当查询时间起点早于2020-08-31，该筛选项失效',
    props: {
      multiple: true,
      emptyValue: [],
      optionList: deliveryMode
    }
  },
  landingType: {
    type: SELECT,
    key: 'landingType',
    paramValue: 'landing_type',
    label: $bp_t('推广目的', 'common.landing_type'),
    props: {
      multiple: true,
      emptyValue: [],
      optionList: landingType
    }
  },
  pricing: {
    type: SELECT,
    key: 'pricing',
    paramValue: 'pricing',
    label: $bp_t('计费方式', 'common.billing_mode'),
    props: {
      multiple: true,
      emptyValue: [],
      optionList: pricing
    }
  },
  // 计费方式-dpa
  pricingDpa: {
    type: SELECT,
    key: 'pricingDpa',
    paramValue: 'pricing',
    label: $bp_t('计费方式', 'common.billing_mode'),
    props: {
      multiple: true,
      emptyValue: [],
      optionList: filterForObj(pricing, (_, key) => ['CPM', 'CPC', 'oCPM', 'oCPC'].includes(key))
    }
  },
  appCode: {
    type: SELECT,
    key: 'appCode',
    paramValue: 'app_code',
    label: LegalText?.reports?.delivery_postion,
    props: {
      multiple: true,
      emptyValue: [],
      optionList: filterForObj(appCode, val => val.isSupported !== false)
    }
  },
  // 广告位-dpa
  appCodeDpa: {
    type: SELECT,
    key: 'appCodeDpa',
    paramValue: 'app_code',
    label: LegalText.reports.delivery_postion,
    props: {
      multiple: true,
      emptyValue: [],
      optionList: appCodeDpa
    }
  },
  convertTypeDpa: {
    type: SELECT,
    key: 'convertTypeDpa',
    paramValue: 'covert_type',
    label: $bp_t('转化跟踪方式', 'common.transform_tracking_mode'),
    props: {
      multiple: true,
      emptyValue: [],
      optionList: convertTypeDpa
    }
  },
  externalActionDpa: {
    type: SELECT,
    key: 'externalActionDpa',
    paramValue: 'external_action',
    label: $bp_t('转化目标', 'common.external_action'),
    props: {
      multiple: true,
      emptyValue: [],
      optionList: externalActionDpa
    }
  },
  platform: {
    type: SELECT,
    key: 'platform',
    paramValue: 'platform',
    label: $bp_t('平台', 'bp.statistics_filter_equipment'),
    props: {
      multiple: true,
      emptyValue: [],
      optionList: platform
    }
  },
  imageMode: {
    type: SELECT,
    key: 'imageMode',
    paramValue: 'image_mode',
    label: $bp_t('创意样式', 'bp.statistics_filter_creative_style'),
    props: {
      multiple: true,
      emptyValue: [],
      optionList: filterForObj(imageMode, val => val.isSupported !== false)
    }
  },
  creativeMaterialMode: {
    type: SELECT,
    key: 'creativeMaterialMode',
    paramValue: 'creative_material_mode',
    label: $bp_t('创意方式', 'bp.statistics_filter_creative_generation_style'),
    props: {
      multiple: true,
      emptyValue: [],
      optionList: creativeMaterialMode
    }
  },
  useDouyin: {
    type: SELECT,
    key: 'native_type',
    paramValue: 'native_type',
    label: $bp_t('是否启用原生', 'common.statistics.filter.useDouyin'),
    hint: '当查询时间起点早于2021-09-15，该筛选项失效',
    props: {
      multiple: true,
      emptyValue: [],
      optionList: useDouyinOptions
    }
  },
  platformVersion: {
    type: SELECT,
    key: 'platformVersion',
    paramValue: 'platform_version',
    label: '平台版本',
    props: {
      multiple: true,
      emptyValue: [],
      optionList: platformVersionOptions
    }
  }
}

export const commonFieldsFilterConfig = {
  cost: {
    type: RANGE_INPUT,
    key: 'cost',
    paramValue: 'stat_cost_range',
    label: $bp_t('消耗', 'common.stat_cost'),
    props: {
      emptyValue: {
        st: '',
        et: '',
        unit: $bp_t('元', 'common.element')
      }
    }
  },
  convertCnt: {
    type: RANGE_INPUT,
    key: 'convertCnt',
    paramValue: 'convert_cnt_range',
    label: $bp_t('转化数', 'common.convert_cnt'),
    props: {
      emptyValue: {
        st: '',
        et: '',
        unit: '',
        isInt: true
      }
    }
  },
  convertCost: {
    type: RANGE_INPUT,
    key: 'convertCost',
    paramValue: 'conversion_cost_range',
    label: $bp_t('转化成本', 'common.conversion_cost'),
    props: {
      emptyValue: {
        st: '',
        et: '',
        unit: $bp_t('元', 'common.element')
      }
    }
  },
  showCnt: {
    type: RANGE_INPUT,
    key: 'showCnt',
    paramValue: 'show_cnt_range',
    label: $bp_t('展示数', 'common.show_cnt'),
    props: {
      emptyValue: {
        st: '',
        et: '',
        unit: '',
        isInt: true
      }
    }
  }
}

// displayType
export const displayType = {
  setData: 'setData', // 设置数据 显示在展开区域第一部分
  fields: 'fields', // 指标数据 显示在展开区域第二部分
  none: 'none' // 不显示在展开区域，但会回显
}

// TODO 理解问题
// TODO 使用问题，针对slot中的内容需要提炼更近一步的处理方法
export const filterConfigGenerator = ({
  setDataFilterConfig = {},
  fieldsFilterConfig = commonFieldsFilterConfig,
  notDisplayFilterConfig = {}
} = {}) => {
  setDataFilterConfig = { ...setDataFilterConfig, ...commonSetDataFilterConfig }
  const displayTypeToConfig = {
    [displayType.none]: notDisplayFilterConfig, // 如果和后续会显示的有冲突那么会显示的优先
    [displayType.setData]: setDataFilterConfig,
    [displayType.fields]: fieldsFilterConfig
  }
  Object.keys(displayTypeToConfig).forEach(displayType => {
    Object.keys(displayTypeToConfig[displayType]).forEach(key => {
      displayTypeToConfig[displayType][key].displayType = displayType
      displayTypeToConfig[displayType][key].key = key
    })
  })
  return Object.assign({}, ...Object.values(displayTypeToConfig))
}

export const isSupportedCdp = Tool.isBp()
  ? (Tool.isBpSupported(425) || Tool.isBpSupported(595))
  : (
    Tool.isSupported(GLOBAL_VAR.adver_func.Cdp_Adv) || // 415
    Tool.isSupported(570) ||
    Tool.isSupported(571)
  )

// 常用filterList
// 四大报表共用，账户、组、计划、创意
const basicAdReportSetDataFilterList = ['pricingCategory', 'campaignType', 'deliveryMode', 'landingType', 'pricing', 'appCode', 'imageMode', 'creativeMaterialMode']

// 无信息流权限账户不显示 广告组类型、投放位置
// BP 无白名单限制
const feedAdReportSetDataFilterList = (Tool.isBp() || advFeedTag) ? basicAdReportSetDataFilterList : basicAdReportSetDataFilterList.filter(key => !['campaignType', 'appCode'].includes(key))
// BP 暂时不显示 imageMode
export const adReportSetDataFilterList = Tool.isBp() ? feedAdReportSetDataFilterList.filter(key => key !== 'imageMode') : feedAdReportSetDataFilterList

export const audienceReportSetDataFilterList = adReportSetDataFilterList.filter(key => key !== 'appCode' && key !== 'imageMode')

export const commonFieldsFilterList = ['cost', 'convertCnt', 'convertCost', 'showCnt']
// 账户报表单独多出来一个筛选项
export const basicAdReportSetDataFilterListAdvertiser = isSupportedCdp ? [...basicAdReportSetDataFilterList, 'platformVersion'] : basicAdReportSetDataFilterList
